import React, { Component } from 'react';
import './style.css';
import Typed from 'typed.js';

export default class BannerSection extends Component {
  downloadCV() {
    // alert("clicked");
    window.location.href = '';
  }

  componentDidMount() {
    const strArr = ['Android Mobile Application', 'IOS Mobile Application'];
    const typed3 = new Typed('#typed', {
      strings: strArr,
      typeSpeed: 52,
      backSpeed: 20,
      smartBackspace: true, // this is a default
      loop: true,
    });
  }

  render() {
    return (
      <header className='masthead'>
        <div className='container'>
          <div className='intro-text'>
            <div className='intro-lead-in'>Welcome To My Portfolio!</div>
            <div className='intro'>
              <span className='msg'>My Pleasure to Help you for</span>{' '}
              <span className='gold' id='typed'></span>
            </div>

            <div className='btnCont row'>
              <a
                className='btn btn-primary text-uppercase js-scroll-trigger more col-md-4'
                href='#about'
              >
                See More
              </a>
              <a
                href='https://drive.google.com/file/d/15CdXiVByaac5PfcEUD-Yh7Lb7wLNr4UC/view'
                target='_blank'
                className='col-md-4 downloadBtn'
              >
                Show My CV
              </a>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
